import * as React from "react";
import { connect } from "react-redux";
import { CoughReOpenCommentGroup } from "../../../../misc/api/apiTypes";
import DropdownCommentsModal, { BaseDropdownModalProps } from "../DropdownCommentsModal/DropdownCommentsModal";
import { GetSelectedOptions, DropdownCommentTypes, ValidateSubmittedComments, ShouldDisplay } from "../DropdownCommentsModal/DropdownCommentsHelpers";
import { MainState } from "../../../../Core/reducers";
import { useWebPortalLegacyClient } from "../../../../misc/api/WebPortalTokenClient";

interface EditReOpenAnalysisSetModalProps extends BaseDropdownModalProps, EditReOpenAnalysisSetModalOwnProps {
    
}

interface EditReOpenAnalysisSetModalOwnProps {
    onClose: () => void;
    analysisSetId: string;
    isAnalysisSetLinked: boolean;
    selectedDropdownCommentType: DropdownCommentTypes;
}

function ValidateEditComments(auditAnnotation: string): string[] {

    const errors = [];

    if (!auditAnnotation.trim()) {
        errors.push("Editing a reopen comment requires a free text input.");
    }

    return errors;
}

const EditReOpenAnalysisSetModal = ({ analysisSetId, selectedDropdownCommentType, ...props }: EditReOpenAnalysisSetModalProps): JSX.Element => {
    const [legacyClient] = React.useState(useWebPortalLegacyClient())

    const updateReOpenReasons = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string) => {
        return legacyClient.updateAnalysisSetReOpenReasons(analysisSetId, auditAnnotation, GetSelectedOptions(selectedComments));
    }

    const fetchReOpenComments = () => {
        return legacyClient.getReOpenAnalysisSetFixedCommentsForSet(analysisSetId);
    }

    const validateReOpenReasons = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string): string[] => {
        return ValidateSubmittedComments(selectedComments).concat(ValidateEditComments(auditAnnotation));
    };

    const shouldDisplay = ShouldDisplay(DropdownCommentTypes.EditReOpen);

    return (shouldDisplay(analysisSetId, selectedDropdownCommentType) ?
        <DropdownCommentsModal
            loading={false}
            editMode={true}
            fetchFixedCommentsForAnalysisSet={fetchReOpenComments}
            header="Update ReOpen Reason"
            showLinkedWarning={false}
            saveFixedComments={updateReOpenReasons}
            show={selectedDropdownCommentType === DropdownCommentTypes.EditReOpen}
            selectedCommentsValidator={validateReOpenReasons}
            {...props}
        /> : null);
};

function mapStateToProps(state: MainState, ownProps: EditReOpenAnalysisSetModalOwnProps): EditReOpenAnalysisSetModalProps {
    return {
        analysisSetId: ownProps.analysisSetId,
        isAnalysisSetLinked: ownProps.isAnalysisSetLinked,
        selectedDropdownCommentType: ownProps.selectedDropdownCommentType,
        onClose: ownProps.onClose
    };
}

export default connect<EditReOpenAnalysisSetModalProps, void, EditReOpenAnalysisSetModalOwnProps>(mapStateToProps)(EditReOpenAnalysisSetModal);
